import { useContext, useEffect, useState } from 'react';
import { Customer } from '../../../domain/customers/customer';
import { AppContext } from '../../../main/context/Provider';
import { useParams } from 'react-router-dom';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { CustomersRepository } from '../../../infrastructure/repositories/customers/customerRepository';
import { Private_Routes } from '../../../main/constants';
import { CustomerForm } from '../components/form/CustomerForm';

export const UpdateCustomerPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const [customer, setCustomer] = useState<Customer>();
    const { id } = useParams<{ id: string }>();

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Actualizar Cliente');

    useEffect(() => {
        if (id) {
            CustomersRepository.GetCustomer(id).then((response) =>
                setCustomer(response)
            );
        }
    }, [id]);

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Clientes',
                route: Private_Routes.CUSTOMER_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.UPDATE_CUSTOMER,
            },
        ]);
    }, [lang]);

    return (
        <>
            {customer != null && (
                <CustomerForm isNewCustomer={false} customer={customer} />
            )}
        </>
    );
};
